import React from 'react';
import styles from './index.css';
import brandData from './brandData.json';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../utils/rel';

class SeriesSearch extends React.PureComponent {
    state = {
        brand: '-1',
        serial: '-1',
        seriesData: [],
        searchHref: '//data.auto.ifeng.com/price',
    };

    brandChange = e => {
        this.setState({
            brand: e.currentTarget.value,
            seriesData: [],
            serial: '-1',
        });
        for (let el in brandData) {
            if (brandData[el].i.toString() === e.currentTarget.value.toString()) {
                this.setState({
                    seriesData: brandData[el].s,
                });
            }
        }
        this.hrefChange(e.currentTarget.value, this.state.serial);
    };
    serialChange = e => {
        this.setState({
            serial: e.currentTarget.value,
        });
        this.hrefChange(this.state.brand, e.currentTarget.value);
    };
    hrefChange = (brand, serial) => {
        if (Number(brand) > 0 && Number(serial) < 0) {
            this.setState({ searchHref: `//car.auto.ifeng.com/brand/${brand}/` });
        } else if (Number(brand) > 0 && Number(serial) > 0) {
            this.setState({ searchHref: `//car.auto.ifeng.com/series/${serial}/` });
        } else if (Number(brand) < 0) {
            this.setState({
                searchHref: '//data.auto.ifeng.com/price',
            });
        }
    };

    render() {
        const { seriesData, searchHref } = this.state;

        return (
            <div className={styles.c_m_i}>
                <select name="brand" onChange={this.brandChange}>
                    <option value="-1">请选择品牌</option>
                    {brandData.map((item, index) => (
                        <option key={index} value={item.i}>
                            {' '}
                            {item.n.split('-')[1]}{' '}
                        </option>
                    ))}
                </select>
                <select name="serial" onChange={this.serialChange}>
                    <option value="-1">请选择系列</option>
                    {seriesData.map((item, index) => (
                        <optgroup key={index} label={item.n}>
                            {item.n}
                            {seriesData[index].b.map((serialItem, serialIndex) => (
                                <option key={serialIndex} value={serialItem.i}>
                                    {serialItem.n}
                                </option>
                            ))}
                        </optgroup>
                    ))}
                </select>
                <a href={searchHref} target="_blank" rel={rel} className={styles.btn}>
                    快速找车
                </a>
            </div>
        );
    }
}

export default errorBoundary(SeriesSearch);
